import React from 'react';
import { useLanguage } from '../../context/language/LanguageContext';
import { punishmentData } from '../../utils/punishmentData';
import './Punishment.css';
import photo1 from '../../assets/images/punishment/pun1.jpg';
import photo2 from '../../assets/images/punishment/pun2.jpg';
import photo3 from '../../assets/images/punishment/pun3.jpg';
import photo4 from '../../assets/images/punishment/pun4.jpg';
import { motion } from 'framer-motion';

const Punishment = () => {
    const { language } = useLanguage();

    return (
        <div className="punishment-page">
            <div className="punishment-hero" style={{ backgroundImage: `url(${photo4})` }}>
                <motion.h1
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    {punishmentData[language].title}
                </motion.h1>
                <motion.div
                    className="punishment-quote"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.3 }}
                >
                    <span className="punishment-quote-mark">"</span>
                    {punishmentData[language].subtitle}
                    <span className="punishment-quote-mark">"</span>
                </motion.div>
            </div>

            <div className="punishment-content">


                <div className="punishment-info-section">
                    {punishmentData[language].sections.map((section, index) => (
                        <motion.div
                            key={index}
                            className="punishment-info-card"
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8, delay: 0.7 + (index * 0.2) }}
                        >
                            <h3>{section.title}</h3>
                            <p>{section.content}</p>
                            {section.punishments && (
                                <ul>
                                    {section.punishments.map((punishment, idx) => (
                                        <li key={idx}>{punishment}</li>
                                    ))}
                                </ul>
                            )}
                        </motion.div>
                    ))}
                </div>

                <motion.div
                    className="punishment-conclusion"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.8, delay: 1.5 }}
                >
                    <p>{punishmentData[language].conclusion}</p>
                </motion.div>
            </div>
        </div>
    );
};

export default Punishment;